module.exports = __webpack_public_path__ + "6fce5bc34685c13839156fee977f26df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/logo.png
// module id = ./assets/images/header/logo.png
// module chunks = 0